import { ConditionalDisplay } from "./styled";

export default ConditionalDisplay;
